import { AccountLimit } from "cy-remittance/registration";
import { AccountLimits } from "./models";
import { ReactNode } from "react";

export function renderAccountLimits(
  accountLimit: AccountLimit<AccountLimits>,
): ReactNode {
  switch (accountLimit.id) {
    case AccountLimits.Standard:
      return <p>Up to ZAR 5,000 per day / ZAR 15,000 per month.</p>;
    case AccountLimits.Boost:
      return (
        <div className="space-y-2">
          <p className="">Up to ZAR 5,000 per day / ZAR 25,000 per month.</p>
          <p className="inline-block rounded font-semibold underline underline-offset-2">
            Proof of income required
          </p>
        </div>
      );
  }
  return null;
}
